import { ROOT_QUESTION_PARENT_ID } from '@/pages/CommunicationsCenter/Tickets/CONST_TICKETS'

export default {
  questions: [],
  ticketFormByQuestions: {},
  ticketForm: {},
  parentQuestionId: ROOT_QUESTION_PARENT_ID,
  questionsSections: [],
}
